var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbsdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.08 1.03998L4.38667 4.73331C4.14 4.97998 4 5.31998 4 5.67331V12.3333C4 13.0666 4.6 13.6666 5.33333 13.6666H11.3333C11.8667 13.6666 12.3467 13.3466 12.56 12.86L14.7333 7.78665C15.2933 6.46665 14.3267 4.99998 12.8933 4.99998H9.12667L9.76 1.94665C9.82667 1.61331 9.72667 1.27331 9.48667 1.03331C9.09333 0.646646 8.46667 0.646646 8.08 1.03998ZM1.33333 13.6666C2.06667 13.6666 2.66667 13.0666 2.66667 12.3333V6.99998C2.66667 6.26665 2.06667 5.66665 1.33333 5.66665C0.6 5.66665 0 6.26665 0 6.99998V12.3333C0 13.0666 0.6 13.6666 1.33333 13.6666Z",
    fill: "#F8F8F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsdown);
export default __webpack_public_path__ + "static/media/thumbsdown.de99339a57767c3668fecec868c6798b.svg";
export { ForwardRef as ReactComponent };